// extracted by mini-css-extract-plugin
export var addToCartButton = "_td-b";
export var arrowButtonContainer = "_td-9";
export var arrowButtonIcon = "_td-a";
export var carouselArrowButton = "_td-6";
export var carouselElementContainer = "_td-1";
export var left = "_td-7";
export var productDisplayCarouselContainer = "_td-0";
export var productTileContainer = "_td-2";
export var productTileImage = "_td-4";
export var productTileImageContainer = "_td-3";
export var productTileTitle = "_td-5";
export var right = "_td-8";
export var sliderOverflow = "_td-c";